/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('PeriodDatasSource', ['ReportTemporalAgregateFunctionType', '$log', 'DayData', 'PrimaryDatasType', 'ReportTotalAgregateFunctionType', 'gettextCatalog', '$filter',
    function (ReportTemporalAgregateFunctionType, $log, DayData, PrimaryDatasType, ReportTotalAgregateFunctionType, gettextCatalog, $filter) {
        var PeriodDatasSource = function (type, period, getDataPrototypeFunction1, getDataPrototypeFunction2, temporalAgregateFunctionType, totalAgregateFunctionType, getPrimaryDatasPrototypeFunction, categorieTable, currentPath, taxMode, typeOfData, additionalFilters) {

            if (/*getDataPrototypeFunction1 &&*/ period.arrayOfDays && categorieTable) {
                this.type = type + "-" + period.type.id;
                this.prototypeDailyFunction1 = getDataPrototypeFunction1;
                this.prototypeDailyFunction2 = getDataPrototypeFunction2;
                this.getPrimaryDatasPrototypeFunction = getPrimaryDatasPrototypeFunction;

                this.arrayOfDay = period.arrayOfDays;
                this.categorieTable = new Array();
                this.additionalFilters = additionalFilters ? additionalFilters : [];

                for (var i = 0; i < categorieTable.length; i++) {
                    if (!categorieTable[i].statFilter || (categorieTable[i].statFilter && categorieTable[i].statFilter(this.arrayOfDay) == true)) {
                        this.categorieTable.push(categorieTable[i]);
                    }
                }

                this.taxMode = taxMode;

                this.parentCategory = currentPath[currentPath.length - 1];
                this.currentPath = currentPath;

                this.stat1ByCategory = new Array();
                this.stat2ByCategory = new Array();

                this.statByCategory = new Array();

                this.totalStat1 = null;
                this.totalStat2 = null;

                this.totalStat = null;

                this.dailyDatas = new Array();
                this.dailyDatas2 = new Array();

                this.monthlyDatas = new Array();
                this.monthlyDatas2 = new Array();

                this.primaryDatas = null;
                this.detailDatas = new Array();

                this.customers = null;
                this.typeOfData = typeOfData;

                this.temporalAgregateFunctionType = temporalAgregateFunctionType;
                this.totalAgregateFunctionType = totalAgregateFunctionType;

                this.nbDays = 0;
                this.nbPassageCustomers = 0;
                this.initDatas();
            }
        }

        PeriodDatasSource.prototype.initDatas = function () {
            var monthlyStat1ByCategory = new Array(),
                monthlyStat2ByCategory = new Array(),
                nbPeriodCurrentCategoryPassageCustomers = 0;

            for (var i = 0; i < this.categorieTable.length; i++) {
                this.stat1ByCategory[this.categorieTable[i].id] = 0;
                this.stat2ByCategory[this.categorieTable[i].id] = 0;
                this.statByCategory[this.categorieTable[i].id] = 0;
                monthlyStat1ByCategory[this.categorieTable[i].id] = 0;
                monthlyStat2ByCategory[this.categorieTable[i].id] = 0;
            }

            var currentMonthMoment = null,
                monthArray = new Array();

            $log.debug(this.type);

            for (var i = 0; i < this.arrayOfDay.length; i++) {
                var day = this.arrayOfDay[i];

                if (day) {
                    var momentMonthOfDay = day.getMomentDate().startOf('month');

                    if (day.isAStatisticDay()) {

                        this.dailyDatas2[day.id] = new Array();

                        for (var j = 0; j < this.categorieTable.length; j++) {
                            var tabCategories = this.currentPath.concat([this.categorieTable[j]]);

                            var stat1 = this.prototypeDailyFunction1.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]);
                            var stat2 = this.prototypeDailyFunction2 ? this.prototypeDailyFunction2.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]) : null;

                            $log.debug(day.id + " " + this.categorieTable[j].label + " stat1 = " + stat1 + "; stat2 = " + stat2);
                            this.stat1ByCategory[this.categorieTable[j].id] += stat1;
                            monthlyStat1ByCategory[this.categorieTable[j].id] += stat1;

                            if (stat2) {
                                this.stat2ByCategory[this.categorieTable[j].id] += stat2;
                                monthlyStat2ByCategory[this.categorieTable[j].id] += stat2;
                            }

                            if (this.prototypeDailyFunction2) {
                                if (stat2 != 0) {
                                    this.dailyDatas2[day.id][this.categorieTable[j].id] = (stat1 / stat2) * (this.typeOfData == 'percent' ? 100 : 1);
                                } else {
                                    //we put 0 in order to have one value by category (the 0 value is not visible in the graph)
                                    this.dailyDatas2[day.id][this.categorieTable[j].id] = 0 * (this.typeOfData == 'percent' ? 100 : 1);
                                }
                            } else {
                                this.dailyDatas2[day.id][this.categorieTable[j].id] = stat1 * (this.typeOfData == 'percent' ? 100 : 1);
                            }

                        }

                        if (this.getPrimaryDatasPrototypeFunction) {
                            if (!this.primaryDatas) this.primaryDatas = new Array();
                            this.primaryDatas = this.primaryDatas.concat(this.getPrimaryDatasPrototypeFunction.apply(day, [this.currentPath, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]));
                        }

                        this.nbDays += 1;
                    }
                }

                if (this.getPrimaryDatasPrototypeFunction && this.currentPath[0] && this.currentPath[0].getSubStatCategories) {
                    var firstCategories = this.currentPath[0].getSubStatCategories();
                    if (firstCategories) {
                        for (var j = 0; j < firstCategories.length; j++) {
                            var tabCategories = [this.currentPath[0], firstCategories[j]],
                                catPrimaryData = this.getPrimaryDatasPrototypeFunction.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]);

                            if (!Array.isArray(catPrimaryData) && typeof (catPrimaryData) == "object") {
                                if (!this.detailDatas[firstCategories[j].id]) this.detailDatas[firstCategories[j].id] = {};
                                for (var prop in catPrimaryData) {

                                    if (typeof (catPrimaryData[prop]) == "number") {
                                        if (!this.detailDatas[firstCategories[j].id][prop]) this.detailDatas[firstCategories[j].id][prop] = 0;

                                        this.detailDatas[firstCategories[j].id][prop] += catPrimaryData[prop];
                                    }
                                }
                            } else {
                                if (Array.isArray(catPrimaryData)) {
                                    if (!this.detailDatas[firstCategories[j].id]) this.detailDatas[firstCategories[j].id] = new Array();

                                    this.detailDatas[firstCategories[j].id] = this.detailDatas[firstCategories[j].id].concat(this.getPrimaryDatasPrototypeFunction.apply(day, [tabCategories, this.additionalFilters, this.arrayOfDay[0], this.arrayOfDay[this.arrayOfDay.length - 1], this.taxMode]));
                                }
                            }
                        }
                    }
                }

                //change of month or init
                if (!currentMonthMoment ||
                    (currentMonthMoment && !currentMonthMoment.isSame(momentMonthOfDay)) ||
                    (currentMonthMoment && i === this.arrayOfDay.length - 1)) {

                    //change of month : put tthe datas of the month in monthlyDatas and reinit variables
                    if (currentMonthMoment != null) {
                        var dayId = currentMonthMoment.format('YYYYMMDD');
                        this.monthlyDatas2[dayId] = new Array();

                        for (var j = 0; j < this.categorieTable.length; j++) {
                            if (this.prototypeDailyFunction2) {
                                if (monthlyStat2ByCategory[this.categorieTable[j].id] != 0) {
                                    this.monthlyDatas2[dayId][this.categorieTable[j].id] = (monthlyStat1ByCategory[this.categorieTable[j].id] / monthlyStat2ByCategory[this.categorieTable[j].id]) * (this.typeOfData == 'percent' ? 100 : 1);
                                } else {
                                    this.monthlyDatas2[dayId][this.categorieTable[j].id] = 0 * (this.typeOfData == 'percent' ? 100 : 1);
                                }
                            } else {
                                this.monthlyDatas2[dayId][this.categorieTable[j].id] = monthlyStat1ByCategory[this.categorieTable[j].id] * (this.typeOfData == 'percent' ? 100 : 1);
                            }
                        }

                        //initialisation of datas for the new month
                        monthlyStat1ByCategory = new Array();
                        monthlyStat2ByCategory = new Array();
                        for (var j = 0; j < this.categorieTable.length; j++) {
                            monthlyStat1ByCategory[this.categorieTable[j].id] = 0;
                            monthlyStat2ByCategory[this.categorieTable[j].id] = 0;
                        }
                    }
                    currentMonthMoment = momentMonthOfDay;
                }

                //calcul the number of passage customers of the period
                nbPeriodCurrentCategoryPassageCustomers += day.getNbPassageCustomersOfSaleObject([this.currentPath[this.currentPath.length - 1]], this.additionalFilters, this.arrayOfDay[0]);

            }

            $log.debug(this.stat1ByCategory);
            $log.debug(this.stat2ByCategory);

            if (!this.prototypeDailyFunction2) {
                var nbCatNotNull = 0;
                for (var i in this.stat1ByCategory) {

                    if (this.temporalAgregateFunctionType === ReportTemporalAgregateFunctionType.DAILY_SUM) {
                        this.statByCategory[i] = this.stat1ByCategory[i];
                    } else if (this.temporalAgregateFunctionType === ReportTemporalAgregateFunctionType.DAILY_AVERAGE && this.nbDays != 0) {
                        this.statByCategory[i] = this.stat1ByCategory[i] / this.nbDays;
                    }

                    this.totalStat += this.statByCategory[i];
                    if (this.statByCategory[i] != 0) {
                        nbCatNotNull++;
                    }
                }
                if (this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES) {
                    this.totalStat = this.totalStat / nbCatNotNull;
                }
            } else {
                var nbCat = 0;

                for (var i in this.stat1ByCategory) {
                    var stat1BayCat = this.stat1ByCategory[i],
                        stat2BayCat = this.stat2ByCategory[i];

                    if (this.temporalAgregateFunctionType === ReportTemporalAgregateFunctionType.DAILY_AVERAGE) {
                        stat1BayCat = stat1BayCat / this.nbDays;
                        stat2BayCat = stat2BayCat / this.nbDays;
                    }

                    var averageStat = null;

                    if (stat2BayCat != 0) {
                        averageStat = stat1BayCat / stat2BayCat;

                        this.totalStat += averageStat;
                        nbCat++;
                    }

                    this.statByCategory[i] = averageStat;

                }

                if (this.totalAgregateFunctionType === ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES) {
                    this.totalStat = this.totalStat / nbCat;
                }

            }
            this.nbPassageCustomers = nbPeriodCurrentCategoryPassageCustomers;
            $log.debug(this.statByCategory);
            this.getCustomers();
            this.sortDatas();

        };

        PeriodDatasSource.prototype.sortDatas = function () {
            var me = this;
            //sort the datas
            this.categorieTable.sort(function (v1, v2) {
                return (me.statByCategory[v2.id] - me.statByCategory[v1.id]);
            });
            this.sortDailyDatas();
            this.sortMonthlyDatas();
        }

        PeriodDatasSource.prototype.sortMonthlyDatas = function () {
            let monthlyDatasFirstRow = new Array();
            monthlyDatasFirstRow.push({id: 'jour', label: 'jour', type: 'date'});

            for (let i = 0; i < this.categorieTable.length; i++) {
                monthlyDatasFirstRow.push(this.categorieTable[i].label);
                monthlyDatasFirstRow.push({type: 'string', role: 'tooltip', 'p': {'html': true}});

            }
            this.monthlyDatas.push(monthlyDatasFirstRow);

            for (let dayId in this.monthlyDatas2) {
                let monthArray = new Array(),
                    day = DayData.getById(dayId);
                if (day) {
                    monthArray.push(DayData.getById(dayId).getDate());

                    for (let j = 0; j < this.categorieTable.length; j++) {
                        let tooltipValue = null;
                        monthArray.push(this.monthlyDatas2[dayId][this.categorieTable[j].id]);

                        if (this.typeOfData === "percent") {
                            tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.monthlyDatas2[dayId][this.categorieTable[j].id], 2) + "%</div>";
                        } else if (this.typeOfData === "currency") {
                            tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("currencyFormatFilter")(this.monthlyDatas2[dayId][this.categorieTable[j].id]) + "</div>";
                        } else if (this.typeOfData === "time") {
                            tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("shorterMinutesToTimeString")(this.monthlyDatas2[dayId][this.categorieTable[j].id]) + "</div>";
                        } else {
                            tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.monthlyDatas2[dayId][this.categorieTable[j].id], 2) + " </div>";
                        }
                        monthArray.push(tooltipValue);
                    }
                    this.monthlyDatas.push(monthArray);
                }
            }
        }

        PeriodDatasSource.prototype.sortDailyDatas = function () {
            var dailyDatasFirstRow = new Array();
            dailyDatasFirstRow.push({id: 'jour', label: 'jour', type: 'date'});

            for (var i = 0; i < this.categorieTable.length; i++) {
                dailyDatasFirstRow.push(this.categorieTable[i].label);
                dailyDatasFirstRow.push({type: 'string', role: 'tooltip', 'p': {'html': true}});
            }

            this.dailyDatas.push(dailyDatasFirstRow);

            for (var dayId in this.dailyDatas2) {
                var dayArray = new Array(),
                    day = DayData.getById(dayId);
                dayArray.push(day.getDate());

                for (var j = 0; j < this.categorieTable.length; j++) {
                    let tooltipValue = null;
                    dayArray.push(this.dailyDatas2[dayId][this.categorieTable[j].id]);

                    if (this.typeOfData === "percent") {
                        tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.dailyDatas2[dayId][this.categorieTable[j].id], 2) + "%</div>";
                    } else if (this.typeOfData === "currency") {
                        tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("currencyFormatFilter")(this.dailyDatas2[dayId][this.categorieTable[j].id]) + "</div>";
                    } else {
                        tooltipValue = "<div style='padding:5px;'><b>" + day.getMomentDate().format('L') + "</b><br/>" + gettextCatalog.getString(this.categorieTable[j].label) + " : " + $filter("smartNumber")(this.dailyDatas2[dayId][this.categorieTable[j].id], 2) + " </div>";
                    }

                    dayArray.push(tooltipValue);
                }

                this.dailyDatas.push(dayArray);
            }
        }

        PeriodDatasSource.prototype.getStatByDay = function () {
            return this.dailyDatas;
        };

        PeriodDatasSource.prototype.getStatByMonth = function () {
            return this.monthlyDatas;
        };

        PeriodDatasSource.prototype.getAgregationOfCategory = function (category) {
            var value = this.statByCategory[category.id];
            if (value == null || value == undefined)
                return null;
            return value * (this.typeOfData == 'percent' ? 100 : 1);
        };

        PeriodDatasSource.prototype.getAgregationOfTotalCategory = function () {
            return (!isNaN(this.totalStat) && this.totalStat != null && this.totalStat != undefined) ? this.totalStat * (this.typeOfData == 'percent' ? 100 : 1) : null;
        };

        PeriodDatasSource.prototype.getAverageFromDetailLevel = function () {
            var total = 0;
            var nbItems = 0;
            for (var c = 0; c < this.categorieTable.length; c++) {
                total += this.stat1ByCategory[this.categorieTable[c].id];
                nbItems += this.stat2ByCategory[this.categorieTable[c].id];
            }
            return total / nbItems;
        };
        PeriodDatasSource.prototype.getCustomers = function () {
            //TODO RETURN {customer : customer, results : {ca:xxx,nbSales:xx}} instead only customer on period
            //TODO MANAGE no customer (de passage)
            var groupArray = [];
            if (this.primaryDatas && this.primaryDatas.length > 0) {
                var type = PrimaryDatasType.getType(this.primaryDatas[0]);
                if (type == PrimaryDatasType.SALE || type == PrimaryDatasType.BOOKING)
                    angular.forEach(this.primaryDatas, function (item, idx) {
                        if (item && item.customer && groupArray.indexOf(item.customer) == -1) {
                            groupArray.push(item.customer);
                        }
                    });
                else if (type == PrimaryDatasType.CUSTOMER)
                    angular.forEach(this.primaryDatas, function (item, idx) {
                        if (item && groupArray.indexOf(item) == -1) {
                            groupArray.push(item);
                        }
                    });
                else if (type == PrimaryDatasType.VISITE)
                    angular.forEach(this.primaryDatas, function (item, idx) {
                        if (item && item.customer && groupArray.indexOf(item.customer) == -1) {
                            groupArray.push(item.customer);
                        }
                    });
                else if (type == PrimaryDatasType.BOOKINGSERVICE)
                    angular.forEach(this.primaryDatas, function (item, idx) {
                        if (item && item.booking && item.booking.customer && groupArray.indexOf(item.booking.customer) == -1) {
                            groupArray.push(item.booking.customer);
                        }
                    });
                /* else if(type == PrimaryDatasType.HROCCUPATIONDATAS) {
                     angular.forEach(this.primaryDatas, function (item, idx) {
                         angular.forEach(item.subBookings, function (subSaleItem, idx2) {
                             if (subSaleItem && subSaleItem.booking && subSaleItem.booking.customer && groupArray.indexOf(subSaleItem.booking.customer) == -1) {
                                 groupArray.push(subSaleItem.booking.customer);
                             }
                         });
                     });
                 }*/
                else if (type == PrimaryDatasType.SALESERVICE || type == PrimaryDatasType.SALEPRODUCT || type == PrimaryDatasType.SALECURE || type == PrimaryDatasType.LOYALTYCARDITEM || type == PrimaryDatasType.GIFTITEM) {
                    angular.forEach(this.primaryDatas, function (item, idx) {
                        if (item && item.sale && item.sale.customer && groupArray.indexOf(item.sale.customer) == -1) {
                            groupArray.push(item.sale.customer);
                        }
                    });
                }
                ;
            }
            this.customers = groupArray;
        };

        PeriodDatasSource.prototype.hasDataOnCategories = function () {
            var hasDataOnCategories = false;
            for (var cat in this.statByCategory) {
                if (this.statByCategory[cat] && this.statByCategory[cat] != 0) {
                    hasDataOnCategories = true;
                    break;
                }
            }
            return hasDataOnCategories;
        }

        return PeriodDatasSource;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/report/PeriodDatasSource.js